export enum OveralVeiligOnlineChangeTypeEnum {
  Upgrade,
  Downgrade
}
